import { ResultState, Result, HeaderInfo, CheckType, ResultTabType } from './state'

export const setResult = function (state: ResultState, result: Result): void {
  state.result = result
}

export const setHeaderInfo = function (state: ResultState, headerInfo: HeaderInfo): void {
  state.headerInfo = headerInfo
}

export const setChecksCounter = function (state: ResultState, checksCounter: number): void {
  state.checksCounter = checksCounter
  state.checksCounterUpdated = true
}

export const setCheckType = function (state: ResultState, checkType: CheckType): void {
  state.checkType = checkType
}

export const setResultTab = function (state: ResultState, resultTabType: ResultTabType): void {
  state.resultTabType = resultTabType
}
